import styled from 'styled-components';
import Icon from '../../Icon';
import {commonPalette} from '../../../styles/palette';

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 32px 16px 32px;
`;

export const OptionWrapper = styled.button`
  transition: all 0.3s;
  text-align: left;
  padding: 10px 12px;
  font-size: 14px;
  border: none;
  border-radius: 3px;
  background: ${p => (p.selected && !p.disabled ? commonPalette.surfaceBrand : '#F7F7F7')};
  color: ${p => (p.selected && !p.disabled ? 'white' : '#575F5F')};
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  ${({optionDisabled}) => (optionDisabled ? 'opacity: 0.5' : '')};

  &:active {
    background: ${p => (!p.disabled ? commonPalette.surfaceBrand : '')};
    color: ${p => (!p.disabled ? 'white' : '')};
  }
`;

export const IconWrapper = styled(Icon)`
  margin: 14px;
  cursor: pointer;
  &:hover {
    color: ${commonPalette.textBrand};
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #f7f7f7;
  color: black;
`;
